import React, { useState, useEffect, useContext,useRef } from "react";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col, Form, InputGroup, Modal, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { RegxExpression } from "../../../utils/common";
import Select from "react-select";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "../../../utils/context";
import { City } from "../../../utils/apis/master/Master";
import { postData } from "../../../utils/api";
import Cookies from "js-cookie";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
const Stepone = ({ user_id ,setShowModal}) => {
  // const [selectedOption, setSelectedOption] = useState(null);
  // const { getData, IMG_URL, Select2Data } = useContext(Context);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  // const {
  //   control,
  //   register,
  //   handleSubmit,
  //   getValues,
  //   setValue,
  //   watch,
  //   setError,
  //   clearErrors,
  //   formState: { errors },
  //   reset,
  //   trigger,
  // } = useForm();
  // const watchWaUpdates = watch("wa_updates", false);
  // const imageFile1 = watch("logo");

  // const onSubmit = async (data) => {
  //   const formData = new FormData();
  //   if (data?.id) {
  //     formData.append("id", data.id);
  //   }
  //   formData.append("store_name", data?.store_name);
  //   formData.append("area", data?.area);
  //   formData.append("contact_no", data?.contact_no);
  //   formData.append("wa_contact_no", data?.wa_contact_no);
  //   formData.append("city_id", data?.city_id?.value);
  //   formData.append("logo", data?.logo[0]);

  //   try {
  //     const res = await postData(
  //       "/employee/seller-details/s-store-details",
  //       formData,
  //     );
  //     if (res?.success) {
  //       // Cookies.set('user_id', res.data.user_id);
  //     } else {
  //       // Handle the case when res.success is false
  //       console.error("Failed to submit data");
  //     }
  //   } catch (error) {
  //     // Handle any errors that occur during the request
  //     console.error("An error occurred while submitting data:", error);
  //   }
  // };

  // const getEditData = async () => {
  //   const res = await getData(`/employee/seller-details/s-store-details/`);
  //   if (res?.success) {
  //     reset(res?.data);
  //   }
  // };
  // useEffect(() => {
  //   getEditData();
  // }, [user_id]);

  // const [city, setCity] = useState([]);
  // const getCity = async () => {
  //   const res = await City();
  //   if (res?.success) {
  //     const data = await Select2Data(res?.data, "city_id", false);
  //     setCity(data);
  //   }
  // };

  // useEffect(() => {
  //   getCity();
  // }, []);



  const { getData: contextGetData, Select2Data } = useContext(Context);

  const [setups, setSetup] = useState({});
  const [selectedRole, setSelectedRole] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [categories, setCategories] = useState([]);
  const [hasSavedPassword, setHasSavedPassword] = useState(false); // Track if password exists in DB

  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);

  

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const togglePasswordVisibility1 = () => setShowPassword1(!showPassword1);

  const handleRadioChange = (e) => {
    setSelectedRole(e.target.id);
    clearErrors("role");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 

  // Load categories
  const loadCategories = async () => {
    try {
      const res = await contextGetData("/allcategories");
      if (res?.success) {
        const opts = await Select2Data(res.data, "category_id", false);
        setCategories(opts);
      }
    } catch (err) {}
  };

   useEffect(() => {
    loadCategories()
  }, []);
  // Load saved draft
  const getEditData = async () => {
    if (!user_id) return;

    try {
      const res = await contextGetData(`/employee/seller-details/${user_id}`);
      if (res?.success) {
        const d = res.data.seller_detail || {};

        setSelectedRole(d.role_type || "");
        setHasSavedPassword(!!d.password); // True if password exists

        reset({
          password: "",
          c_password: "",
          longitude: d.longitude || "",
          latitude: d.latitude || "",
          store_address: d.store_address || "",
          category_id: null,
          manager_name: d.manager_name || "",
          manager_email: d.manager_email || "",
          manager_contact_no: d.manager_contact_no || "",
        });

        // if (d.category_id) {
        //   const cat = categories.find((c) => c.value == d.category_id);
        //   if (cat) setValue("category_id", cat);
        // }

        if (res.data.seller_categories?.length) {
          const selectedCats = res.data.seller_categories
            .map((sc) => categories.find((c) => c.value === sc.category_id))
            .filter(Boolean);

          setValue("category_id", selectedCats);
        }

        if (d.latitude && d.longitude && map && marker) {
          const pos = {
            lat: parseFloat(d.latitude),
            lng: parseFloat(d.longitude),
          };
          map.panTo(pos);
          marker.setPosition(pos);
        }
      }
    } catch (err) {}
  };

  

  useEffect(() => {
    if (user_id) getEditData();
  }, [user_id, categories, map]);

  // Initialize Google Map
  useEffect(() => {
    if (!window.google || !mapRef.current || map) return;

    const defaultCenter = { lat: 18.5204, lng: 73.8567 };
    const mapInstance = new window.google.maps.Map(mapRef.current, {
      center: defaultCenter,
      zoom: 15,
      mapTypeControl: false,
      streetViewControl: false,
    });

    const markerInstance = new window.google.maps.Marker({
      position: defaultCenter,
      map: mapInstance,
      draggable: true,
    });

    mapInstance.addListener("click", (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      markerInstance.setPosition({ lat, lng });
      setValue("latitude", lat.toFixed(6));
      setValue("longitude", lng.toFixed(6));
    });

    setMap(mapInstance);
    setMarker(markerInstance);
  }, []);

  const onSubmit = async (data) => {
    if (!selectedRole) {
      setError("role", { message: "Role is required" });
      return;
    }

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("role_type", selectedRole);
    formData.append("longitude", data.longitude || "");
    formData.append("latitude", data.latitude || "");
    formData.append("store_address", data.store_address);
    // formData.append("category_id", data.category_id?.value || "");
    const categoryIds = (data.category_id || []).map((c) => c.value);

    formData.append("category_id", JSON.stringify(categoryIds));

    // Only send password if it's the first time or user typed a new one
    if (!hasSavedPassword || (data.password && data.password.trim() !== "")) {
      if (!data.password || data.password !== data.c_password) {
        setError("c_password", { message: "Passwords do not match" });
        return;
      }
      formData.append("password", data.password);
    }

    if (selectedRole === "Manager") {
      formData.append("manager_name", data.manager_name);
      formData.append("manager_email", data.manager_email);
      formData.append("manager_contact_no", data.manager_contact_no);
    }

    try {
      const res = await postData("/employee/seller-details/add-two", formData);
       if (res?.success) {
         setShowModal({ code: res.code, message: res.message });
         // setNewUserContact(res?.data?.contact_no)
         // props.nextStep()
       } else {
         // Handle the case when res.success is false
         await setShowModal({ code: res.code, message: res.message });
       }
       setTimeout(() => {
         setShowModal(0);
       }, 1000);
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <>
      <div className="personal-details-form ">
        <div className="details-form-holder">
          <div className="form-container">
            <Form onSubmit={handleSubmit(onSubmit)}>
              {/* Role */}
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Select Role
                    </Form.Label>
                    <div className="row get-otp-text">
                      <div className="col-lg-6">
                        <Form.Check
                          type="radio"
                          label="Owner"
                          id="Owner"
                          checked={selectedRole === "Owner"}
                          onChange={handleRadioChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <Form.Check
                          type="radio"
                          label="Manager"
                          id="Manager"
                          checked={selectedRole === "Manager"}
                          onChange={handleRadioChange}
                        />
                      </div>
                      {!selectedRole && errors.role && (
                        <span className="text-danger">
                          {errors.role.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Password Fields - Always visible */}
              <div className="row ">
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Create Password*
                    </Form.Label>
                    <div className="password_div">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder={
                          hasSavedPassword
                            ? "Leave blank to keep current"
                            : "Enter password"
                        }
                        {...register("password", { required: "Password Required" })}
                        className={classNames("", {
                          "is-invalid": errors.password,
                        })}
                      />
                      <div className="eye_icon_holder">

                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                        className="eyeicn"
                        onClick={togglePasswordVisibility}
                      />
                      </div>
                    </div>
                    {errors.password && (
                      <span className="text-danger">
                        {errors.password.message}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required">
                      Confirm Password*
                    </Form.Label>
                    <div className="password_div">
                      <Form.Control
                        type={showPassword1 ? "text" : "password"}
                        placeholder={
                          hasSavedPassword
                            ? "Leave blank to keep current"
                            : "Confirm password"
                        }
                        {...register("c_password", {
                          required: !hasSavedPassword
                            ? "Please confirm password"
                            : false,
                          validate: (value) => {
                            if (
                              !hasSavedPassword &&
                              watch("password") &&
                              value !== watch("password")
                            ) {
                              return "Passwords do not match";
                            }
                            return true;
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors.c_password,
                        })}
                      />
                      <div className="eye_icon_holder">

                      <FontAwesomeIcon
                        icon={showPassword1 ? faEyeSlash : faEye}
                        className="eyeicn"
                        onClick={togglePasswordVisibility1}
                      />
                      </div>
                    </div>
                    {errors.c_password && (
                      <span className="text-danger">
                        {errors.c_password.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Manager Fields */}
              {selectedRole === "Manager" && (
                <div className="row ">
                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required form-field">
                        Manager Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        {...register("manager_name", { required: "Required" })}
                      />
                      {errors.manager_name && (
                        <span className="text-danger">
                          {errors.manager_name.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required form-field">
                        Manager Email ID
                      </Form.Label>
                      <Form.Control
                        type="email"
                        {...register("manager_email", { required: "Required" })}
                      />
                      {errors.manager_email && (
                        <span className="text-danger">
                          {errors.manager_email.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="field-bottom">
                      <Form.Label className="required form-field">
                        Manager Contact Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={10}
                        {...register("manager_contact_no", {
                          required: "Required",
                        })}
                      />
                      {errors.manager_contact_no && (
                        <span className="text-danger">
                          {errors.manager_contact_no.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Map */}
              <div style={{ width: "100%" }} className="mb-4">
                <Form.Label className="required form-field">
                  Shop Location
                </Form.Label>
                <div
                  ref={mapRef}
                  style={{
                    width: "100%",
                    height: "350px",
                    borderRadius: "12px",
                    border: "2px solid #ddd",
                    overflow: "hidden",
                  }}
                />
                <small className="text-muted">
                  Click on map to set location
                </small>
              </div>

              {/* Lat/Lng */}
              <div className="row ">
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Longitude
                    </Form.Label>
                    <Form.Control
                      type="text"
                      readOnly
                      {...register("longitude")}
                      placeholder="Auto-filled"
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Latitude
                    </Form.Label>
                    <Form.Control
                      type="text"
                      readOnly
                      {...register("latitude")}
                      placeholder="Auto-filled"
                    />
                  </div>
                </div>
              </div>

              {/* Address */}
              <div className="row ">
                <div className="col-md-12 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Store Address
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      {...register("store_address", { required: "Required" })}
                    />
                  </div>
                </div>
              </div>

              {/* Category */}
              <div className="row ">
                <div className="col-md-6 mb-3">
                  <div className="field-bottom">
                    <Form.Label className="required form-field">
                      Business Category
                    </Form.Label>
                    {/* <Select
                  options={categories}
                  onChange={(opt) => setValue("category_id", opt)}
                  value={
                    categories.find(
                      (c) => c.value === watch("category_id")?.value
                    ) || null
                  }
                  placeholder="Select Category"
                  isSearchable
                /> */}
                    <Select
                      options={categories}
                      isMulti
                      onChange={(opts) => setValue("category_id", opts)}
                      value={watch("category_id") || []}
                      placeholder="Select Categories"
                      isSearchable
                    />
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="col-md-12 mb-3">
                <div className="text-end apply_now_btn">
                  <div className="registerContinueMain">
                    
                    <Button type="submit" className="walletBtn">
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
            {/* <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="">
                <div className="row ">
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">City</Form.Label>

                      <Controller
                        name="city_id" // name of the field
                        control={control}
                        rules={{ required: "Select City" }}
                        render={({ field }) => (
                          <Select
                            styles={{
                              control: (baseStyles) => ({
                                ...baseStyles,
                                borderColor: errors.city_id
                                  ? "red"
                                  : baseStyles.borderColor,
                              }),
                            }}
                            {...field}
                            options={city}
                          />
                        )}
                      />

                      {errors.city_id && (
                        <span className="text-danger">
                          {errors.city_id.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="area">
                        <Form.Label className="required">Area</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="area"
                            placeholder="Area"
                            className={classNames("", {
                              "is-invalid": errors?.area,
                            })}
                            {...register("area", {
                              required: "Area is required",
                            })}
                          />
                        </InputGroup>
                        {errors.area && (
                          <span className="text-danger">
                            {errors.area.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </div>
              </div>

              
              <div className="">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-field">
                      <Form.Group controlId="store_name">
                        <Form.Label className="required">
                          Shop / Showroom Name*
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="store_name"
                          placeholder="Enter Shop/Showroom Name"
                          {...register("store_name", {
                            required: "Store name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.store_name,
                            "is-valid": getValues("store_name"),
                          })}
                        />
                        {errors.store_name && (
                          <span className="text-danger">
                            {errors.store_name.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="contact_no">
                        <Form.Label className="required form-field">
                          Owner Contact*
                        </Form.Label>
                        <div className="get-otp-text">
                          <Form.Control
                            type="text"
                            name="contact_no"
                            placeholder="Contact No."
                            {...register("contact_no", {
                              required: "Contact number is required",
                              validate: {
                                isTenDigits: (value) =>
                                  (value && value.length === 10) ||
                                  "Contact number must be 10 digits",
                                isNumeric: (value) =>
                                  /^\d+$/.test(value) ||
                                  "Contact number must be numeric",
                              },
                            })}
                            className={classNames("", {
                              "is-invalid": errors?.contact_no,
                              "is-valid":
                                !errors?.contact_no &&
                                getValues("contact_no")?.length === 10,
                            })}
                            onKeyDown={(event) => {
                              const { key } = event;
                              if (
                                !/[0-9]/.test(key) &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                              if (
                                event.target.value?.length >= 10 &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                            }}
                          />
                          {errors.contact_no && (
                            <span className="text-danger">
                              {errors.contact_no.message}
                            </span>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <Form className="field-bottom">
                      <Form.Group controlId="wa_contact_no">
                        <Form.Label className="required">
                          WhatsApp Number*
                        </Form.Label>
                        <div className="get-otp-text">
                          <Form.Control
                            type="text"
                            name="wa_contact_no"
                            placeholder="WhatsApp No."
                            {...register("wa_contact_no", {
                              required: "Contact number is required",
                              validate: {
                                isTenDigits: (value) =>
                                  (value && value.length === 10) ||
                                  "Contact number must be 10 digits",
                                isNumeric: (value) =>
                                  /^\d+$/.test(value) ||
                                  "Contact number must be numeric",
                              },
                            })}
                            className={classNames("", {
                              "is-invalid": errors?.wa_contact_no,
                              "is-valid":
                                !errors?.wa_contact_no &&
                                getValues("wa_contact_no")?.length === 10,
                            })}
                            onKeyDown={(event) => {
                              const { key } = event;
                              if (
                                !/[0-9]/.test(key) &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                              if (
                                event.target.value?.length >= 10 &&
                                key !== "Backspace" &&
                                key !== "Tab"
                              ) {
                                event.preventDefault();
                              }
                            }}
                          />
                          {errors.wa_contact_no && (
                            <span className="text-danger">
                              {errors.wa_contact_no.message}
                            </span>
                          )}
                        </div>
                      </Form.Group>
                    </Form>
                  </div>

                  <div className="col-md-6">
                    <div className="form-field mb-4">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">Logo*</Form.Label>
                        <div>
                          <Form.Control
                            className={classNames("", {
                              "is-invalid": errors?.logo,
                            })}
                            type="file"
                            {...register("logo", {
                              validate: async (value) => {
                                if (typeof value !== "string") {
                                  const fileTypes = ["jpg", "png", "jpeg"];
                                  const fileType =
                                    value[0]?.name?.split(".")[1];

                                  if (!fileTypes.includes(fileType)) {
                                    return `please upload a valid file format. (${fileTypes})`;
                                  }
                                }
                              },
                            })}
                            accept=".jpg, .jpeg, .png"
                            multiple={false}
                          />
                        </div>
                      </Form.Group>
                    </div>
                  </div>

                  <div className="note">
                    <p>
                      Get Latest updates on{" "}
                      <FontAwesomeIcon icon={faWhatsapp} className="ms-3" />{" "}
                      WhatsApp
                      <span className="ms-2">
                        <FontAwesomeIcon icon="fa-brands fa-whatsapp" />
                      </span>
                    </p>
                    <div className="on-off">
                      <Controller
                        name="wa_updates"
                        control={control}
                        render={({ field }) => (
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            label="WhatsApp Updates"
                            {...field}
                            onChange={(e) =>
                              setValue("wa_updates", e.target.checked)
                            }
                            checked={field.value}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="main-form-section mb-3">
                    <Row className="justify-content-center">
                      <Form.Label>Image Preview </Form.Label>

                      {typeof getValues("logo") == "string" ? (
                        <div
                          className="image-preview-container mt-3"
                          
                        >
                          <img
                            src={IMG_URL + getValues("logo")}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "50px", height: "50px" }}
                          />
                        </div>
                      ) : (
                        imageFile1 &&
                        imageFile1?.length > 0 && (
                          <div
                            className="image-preview-container mt-3"
                            
                          >
                            <img
                              // src={URL.createObjectURL(getValues("image")[0])}
                              src={URL?.createObjectURL(imageFile1[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "50px", height: "50px" }}
                            />
                          </div>
                        )
                      )}
                    </Row>
                  </div>
<hr/>
                  <div className="col-md-12">
                    <div className="text-center apply_now_btn">
                      <div className="registerContinueMain">
                        <Button className="walletBtn" type="submit">
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Stepone;
